<template>
    <div class="scrollable-container">
        <div>
            <div class="search-bar-gray d-flex">
                <v-btn @click="gettingData(null, 'search', true)"><v-icon>mdi-magnify</v-icon></v-btn>
                <v-text-field v-model="searchVal" solo :label="$t('res_Label_SearchPlaceHolder')" @keydown.enter="searchFieldKeydownHandler"></v-text-field>
                <div class="custom-icon-wrapper" v-if="searchVal != ''">
                    <v-icon @click="reset()">custom-icon mdi-close</v-icon>
                </div>
            </div>
            <v-treeview class="mt-4" :load-children="gettingData" :items="items">
                <template v-slot:label="{ item }">
                    <div class="d-flex align-items-center">
                        <div>
                            <v-checkbox v-model="value" :value="item" dense></v-checkbox>
                        </div>
                        <div>
                            <span class="v-treeview-node__inner-label mr-1">{{ item.name }}</span>
                        </div>
                    </div>
                </template>
            </v-treeview>
            <div class="dialog-footer d-flex align-items-center justify-content-end gap-3 mt-2">
                <v-btn color="light-blue" @click="closeDmsCabinetTreeDialog">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                <v-btn color="primary" @click="handleSelectFromDmsCabinetTree">{{ $t("res_ButtonText_Add") }}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '@/assets/js/constants';
import axios from 'axios';


export default{
    name: "DmsCabinetTree",
    data(){
        return{
            searchVal: "",
            items: [],
            value: null
        }
    },
    mounted() {
        this.reset();
    },
    methods: {
        gettingData(parent, CalledFrom, searchFromTree){
            //CalledFrom (cabinet, search, parent)

            let parentId = ""
            if(parent != undefined && parent != null ){
                CalledFrom = "parent"
                parentId = parent.id;
            }

            let url = `${constants.baseApiUrl}DMS/GetAllDmsCabinets?SearchText=${this.searchVal}&CalledFrom=${CalledFrom}&parentId=${parentId}`;
                
            axios.get(url)
                    .then(res => 
                    {
                        if(CalledFrom == "parent")
                            parent.children = res.data
                        else if(searchFromTree != undefined && searchFromTree != null && searchFromTree == true){
                            this.items = this.buildTree(res.data);
                        }
                        else
                            this.items = res.data;
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
        },
        reset() 
        {
            this.searchVal = '';
            this.items = [];
            this.gettingData(null, 'cabinet');
        },
        closeDmsCabinetTreeDialog(){
            this.$emit('close-dialog');
        },
        handleSelectFromDmsCabinetTree(){
            this.$emit('handleSelectedChanged', this.value);
            this.closeDmsCabinetTreeDialog();
        },
        buildTree(data){
            console.log(data);

            // Map items by parentId
            const map = {};
            data.forEach(item => {
                map[item.parentId] = map[item.parentId] || [];
                map[item.parentId].push(item);
            });

            // Recursive function to build the tree
            function addChildren(parent) {
                if (map[parent.id]) {
                    parent.children = map[parent.id].map(child => addChildren(child));
                }
                return parent;
            }

            // Build the tree starting from the roots (parentId is null)
            return (map[null] || []).map(root => addChildren(root));

        }

    }
}
</script>